import { Component, OnInit, inject } from "@angular/core";
import { Observable } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { BaseIndexModule } from "../../shared/base/modules/base-index.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslationModule } from "src/app/i18n";



import {
  GetEnumValuesDto,
  GetWebhooksWithPaginationDto,
  PaginatedListOfGetWebhooksWithPaginationDto,
} from "../../../core/api/models";
import { WebhookService } from "../../../core/api/services/webhook.service";
import { BaseIndexPageComponent } from "../../shared/base/components/base-index-page.component";
import { WebhookDto } from "./../../../core/api/models/webhook-dto";
import { FormPageConfig } from "./../../../core/models/form-page-config.model";
import { PageNames } from "src/app/configs/page-names.enum";
import { WebHookFormComponent } from "./web-hook-form/web-hook-form.component";
import { WebhookTypeDirective } from "./shared/web-hook-type.directive";


@Component({
    selector: "app-web-hook",
    templateUrl: "./web-hook.component.html",
    imports: [
        BaseIndexModule,
        WebHookFormComponent,
        WebhookTypeDirective,
    ]
})
export class WebHookComponent extends BaseIndexPageComponent implements OnInit {
  //#region Properties

  pageName = PageNames.webhook;

  /* binding service endpoints */
  protected currentService = inject(WebhookService);
  paginationApiMethodName: string = this.currentService.webhookGetWebhooksWithPagination.name;
  createGetApiMethodName: string = this.currentService.webhookCreateGet.name;
  auditApiMethodName: string = this.currentService.webhookGetWebhooksAudit.name;
  deleteApiMethodName: string = this.currentService.webhookDelete.name;
  /* binding service endpoints */


  modelWithPagination$: Observable<PaginatedListOfGetWebhooksWithPaginationDto>;
  items$: Observable<Array<GetWebhooksWithPaginationDto>>;
  formPageConfig: FormPageConfig<WebhookDto> = {};
  WebhookTypeEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor() {
    super();
  }
  ngOnInit() {
    super.ngOnInit();
    // this.pageConfig.isVisibleForm = true;
  }
  getEnumsValues() {
    this.getEnumValuesApi("WebhookType")
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.WebhookTypeEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.title, name: "title", hasSearch: true },
      {
        title: this.localizer.organization,
        name: "organizationName",
        hasSearch: true,
      },
      { title: `${this.tableVocabs}url`, name: "url", hasSearch: true },
      {
        title: `${this.tableVocabs}webhookType`,
        name: "webhookType",
        hasSearch: true,
        type: "enum",
        enumName: "WebhookType",
      },
      {
        title: `${this.tableVocabs}tryCount`,
        name: "tryCount",
        hasSearch: true,
        type: "number",
      },
      {
        title: this.localizer.active,
        name: "isActive",
        type: "boolean",
        hasSearch: true,
      },
      {
        title: this.localizer.createDate,
        name: "created",
        hasSearch: true,
        type: "dateTime",
      },
    ];
  }

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .webhookUpdateGet({ Id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //#endregion
}
